import { apiRequest, apiEndPoints, methodType } from "./_apiConfig";

export const getLMSTokenRequest = async (data = {}) => {
  return apiRequest(
    methodType.GET,
    apiEndPoints.fetchLMSDashboardUrl,
    data,
    true
  );
};
